// 侧边栏分区：把后端菜单按「运营者(operator) / 管理员(admin)」职责拆分。
// 运营者日常只需：首页仪表盘、设备管理(My Machines)、交易复核，外加商品/分析等运营工具；
// 管理员专属控制（品牌、设备台账、系统、日志、远程/OTA、应用）收纳进可折叠的「管理」区。
//
// 分类以「路由 path 前缀」为主（最稳健，不依赖后端分组名/组件名拼写）。
// 未命中任何管理员前缀者一律归为运营者，避免误藏运营入口。

// 置顶必备项（运营者最常用）——按此顺序钉在最上方
export const ESSENTIAL_COMPONENTS = ["TransactionReview", "MachinesHub", "ProductHub", "Coupons", "AdvertsHub", "AnalyticsHub"];

// 导航图标覆盖（后端菜单图标大多雷同，这里按组件名给出有辨识度的图标）
export const NAV_ICONS = {
  Coupons: "el-icon-discount"
};

// 管理员专属区域（按 path 前缀）
//  /promote      → 品牌(Branding)
//  /machine/admin→ 设备台账/注册表(Machine Registry & ledger)
//  /system       → 系统设置/字典/证件
//  /authority    → 角色/菜单/权限/用户 + 日志(登录/操作/隐私同意)
//  /upgrade      → 远程/OTA 推送更新
//  /myapps       → 应用管理
const ADMIN_PATH_PREFIXES = ["/promote", "/machine/admin", "/system", "/authority", "/upgrade", "/myapps"];

const startsWithPrefix = (path, prefix) => path === prefix || path.indexOf(prefix + "/") === 0 || path.indexOf(prefix) === 0;

// 判断单个导航项（叶子）属于 admin 还是 operator
export const classifyNav = ({ path, component } = {}) => {
  const p = String(path || "");
  // 连接日志(OfflineRecord / Connectivity Log)归入「管理」区
  if (component === "OfflineRecord") {
    return "admin";
  }
  // 经销商自有设备(/machine/user)始终是运营者，不能被 /machine 误判
  if (p.indexOf("/machine/user") === 0) {
    return "operator";
  }
  if (ADMIN_PATH_PREFIXES.some(prefix => startsWithPrefix(p, prefix))) {
    return "admin";
  }
  return "operator";
};

export const isEssential = component => ESSENTIAL_COMPONENTS.indexOf(component) !== -1;

export default { classifyNav, isEssential, ESSENTIAL_COMPONENTS, NAV_ICONS };
